export const getParams = (params?: any) => {
  const urlSearchParams = new URLSearchParams()

  params.forEach((obj: { [paramName: string]: any }) => {
    for (const key in obj) {
      if (Object.prototype.hasOwnProperty.call(obj, key)) {
        const value = obj[key]

        // remove duplicates:
        if (urlSearchParams.has(key)) {
          if (!key.includes('[]')) {
            urlSearchParams.delete(key)
          }
        }

        urlSearchParams.append(key, value)
      }
    }
  })

  return urlSearchParams
}
